export const formatPrice = (amount = 0) => {
  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });

  return currencyFormatter.format(Math.ceil(parseFloat(amount) * 100) / 100);
};

export const discountPrice = (price, discount) => {
  return price * ((100 - discount) / 100);
};
